import { css } from "@emotion/css";
import { ArrowLeftIcon } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import React from "react";
import { ProjectStatusItem } from "~/areas/projects/components/ProjectStatus/ProjectStatusItem";
import { StatusBar } from "~/areas/projects/components/ProjectStatus/StatusBar";
import type { ProjectCreatedOption } from "~/areas/projects/components/Projects/AddProject";
import AddProject from "~/areas/projects/components/Projects/AddProject";
import type { DoBusyTask } from "../DataBaseComponent";
import InternalLink from "../Navigation/InternalLink";
import { GuidedSetupFrame } from "../OnboardingDialog/GuidedSetupFrame";
import addProjectImageDark from "./assets/img-addproject-dark.svg";
import addProjectImageLight from "./assets/img-addproject-light.svg";
interface CreateNewProjectProps {
    spaceId: string;
    projectGroupId?: string;
    next: (project: ProjectResource, option: ProjectCreatedOption) => void;
    back: () => void;
    close: () => void;
    doBusyTask: DoBusyTask;
    isOnboarding: boolean;
}
function CreateNewProject(props: CreateNewProjectProps) {
    const onBackClicked = () => {
        props.back();
    };
    const onProjectCreated = (project: ProjectResource, option: ProjectCreatedOption) => {
        props.next(project, option);
    };
    const helpPanelContent = (<div>
            A <strong>project</strong> represents a specific software component, service, or database that you want to deploy and manage. Each project has its own deployment process.
        </div>);
    return (<GuidedSetupFrame helpPanelImage={{ src: addProjectImageLight, altText: "Add New Project", darkThemeSrc: addProjectImageDark }} helpPanelContent={helpPanelContent} onClose={props.close}>
            <div className={createNewProjectStyles.projectContainer}>
                <div className={createNewProjectStyles.project}>
                    {!props.isOnboarding && (<InternalLink className={createNewProjectStyles.projectsLink} to={links.projectsPage.generateUrl({ spaceId: props.spaceId })} onClick={props.close}>
                            <ArrowLeftIcon />
                            <span>Projects</span>
                        </InternalLink>)}
                    <StatusBar>
                        <ProjectStatusItem name="Project" state="Current"/>
                        <ProjectStatusItem name="Environments" state="Pending"/>
                        <ProjectStatusItem name="Deployment process" state="Pending"/>
                        <ProjectStatusItem name="Release and deploy" state="Pending"/>
                    </StatusBar>

                    <AddProject spaceId={props.spaceId} projectCreated={onProjectCreated} hideEnvironmentConfigWarning={true} projectNameTextBoxLabel="Project name" groupId={props.projectGroupId} title="Add New Project" saveButtonLable="Next" cancelButtonLabel="Back" onCancelled={onBackClicked} isKubernetesGuidedSetup={true} isOnboarding={props.isOnboarding}/>
                </div>
            </div>
        </GuidedSetupFrame>);
}
const createNewProjectStyles = {
    projectContainer: css({
        flexBasis: "100%",
        "& .MuiDialogContent-root, & .MuiDialogActions-root, & .MuiDialogTitle-root .MuiTypography-root div": {
            padding: "0 !important",
        },
        "& .MuiDialogContent-root div[role='alert'] + div": {
            marginTop: space["32"],
        },
        "& .MuiDialogTitle-root .MuiTypography-root": {
            padding: `${space["48"]} 0 ${space["32"]} 0 !important`,
            "& .MuiLinearProgress-root[role='progressbar']": {
                display: "none",
            },
        },
    }),
    project: css({
        paddingTop: space["40"],
    }),
    projectsLink: css({
        paddingBottom: space[16],
        display: "flex",
        font: text.breadcrumb.small,
        gap: space["4"],
    }),
};
export default CreateNewProject;
